import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EmailComponent } from "./email.component";
import { FrameworkModule } from "@app/framework/framework.module";
import { FormsModule } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { HttpLoaderFactory } from "@app/app.module";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { SharedModule } from "@app/shared/shared.module";

@NgModule({
  declarations: [EmailComponent],
  exports: [EmailComponent],
  imports: [
    SharedModule,
    FrameworkModule,
    CommonModule,
    FormsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
})
export class EmailModule {}
